/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Present when the scan was blocked by a player-level restriction.
 * @export
 * @interface TicketScanResponseRestriction
 */
export interface TicketScanResponseRestriction {
    /**
     * Timestamp at which the restriction expires. `null` if indefinite.
     * @type {Date}
     * @memberof TicketScanResponseRestriction
     */
    lockoutExpiresAt?: Date | null;
}

/**
 * Check if a given object implements the TicketScanResponseRestriction interface.
 */
export function instanceOfTicketScanResponseRestriction(value: object): value is TicketScanResponseRestriction {
    return true;
}

export function TicketScanResponseRestrictionFromJSON(json: any): TicketScanResponseRestriction {
    return TicketScanResponseRestrictionFromJSONTyped(json, false);
}

export function TicketScanResponseRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketScanResponseRestriction {
    if (json == null) {
        return json;
    }
    return {
        
        'lockoutExpiresAt': json['lockoutExpiresAt'] == null ? undefined : (new Date(json['lockoutExpiresAt'])),
    };
}

export function TicketScanResponseRestrictionToJSON(value?: TicketScanResponseRestriction | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lockoutExpiresAt': value['lockoutExpiresAt'] == null ? undefined : ((value['lockoutExpiresAt'] as any).toISOString()),
    };
}

